// apps/web/src/admin/DocPreviewModal.tsx
// Shared admin preview overlay: plays a guide's intro video inline (<video>) or
// renders their résumé (<iframe>, PDF), with an "Open in new tab" fallback for
// non-PDF résumés. Used by the applications review console and the user drawer.
import { ModalOverlay } from '../components/ModalOverlay.js';

export function DocPreviewModal({ url, kind, onClose }: { url: string; kind: 'video' | 'resume'; onClose: () => void }) {
  return (
    <ModalOverlay className="z-50 bg-black/70" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="relative w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
        <div className="absolute -top-9 right-0 flex gap-4">
          <a href={url} target="_blank" rel="noopener noreferrer" className="text-white text-sm hover:underline">Open in new tab ↗</a>
          <button onClick={onClose} className="text-white text-sm hover:underline">Close ✕</button>
        </div>
        {kind === 'video' ? (
          /* eslint-disable-next-line jsx-a11y/media-has-caption */
          <video src={url} controls autoPlay className="w-full max-h-[80vh] rounded-lg bg-black" />
        ) : (
          <iframe src={url} title="Résumé" className="w-full h-[80vh] rounded-lg bg-white" />
        )}
      </div>
    </ModalOverlay>
  );
}
